module.exports = __webpack_public_path__ + "img/radio-off.80dba237.svg";